import misRutas from 'vue-routes-generator'

import AgendaComercial from './app.vue'
import ListadosAgendaComercial from './componentes/listados/listados'
import CalendarioAgendaComercial from './componentes/calendario/calendario'
import ListadosPropuestasComerciales from './componentes/propuestas/listado-propuestas'
import EstadisticasAgenda from './componentes/estadisticas/estadisticas'

export default {
	install: Vue => {
		misRutas.route('/main').child('agenda-comercial', {
			name: 'Agenda comercial',
			component: AgendaComercial
		})

		misRutas.route('/main').child('agenda-comercial').child('listados', {
			name: 'Listados',
			component: ListadosAgendaComercial
		})

		misRutas.route('/main').child('agenda-comercial').child('listados/:id', {
			name: 'Detalle de entrada',
			component: ListadosAgendaComercial
		})

		misRutas.route('/main').child('agenda-comercial').child('calendario', {
			name: 'Calendario',
			component: CalendarioAgendaComercial
		})

		misRutas.route('/main').child('agenda-comercial').child('propuestas', {
			name: 'Propuestas',
			component: ListadosPropuestasComerciales
		})

		misRutas.route('/main').child('agenda-comercial').child('estadisticas', {
			name: 'Estadísticas',
			component: EstadisticasAgenda
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/agenda-comercial/vue/index.js